import React from "react";
import { Button } from "../ui/button";
import { LogOut } from "lucide-react";
import { useThemeStore } from "../../store/useThemeStore";

function contrastColor(hex) {
  if (!hex || hex.length < 4) return '#111827';
  const full = hex.length === 4
    ? '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3]
    : hex;
  const r = parseInt(full.slice(1, 3), 16);
  const g = parseInt(full.slice(3, 5), 16);
  const b = parseInt(full.slice(5, 7), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 >= 128 ? '#111827' : '#ffffff';
}

export function Header({ isLoggedIn, onLogout }) {
  const { theme } = useThemeStore();
  const [isDark] = React.useState(() => document.documentElement.classList.contains('dark'));
  const logoSrc  = theme.logo_url || "/logo.png";
  const title    = theme.header_title || "Cessão de Crédito - Processo de Insalubridade/Periculosidade";
  const bg       = isDark ? '#24261F' : (theme.header_bg || '#ffffff');
  const fg       = isDark ? '#E8E6E1' : contrastColor(theme.header_bg || '#ffffff');

  return (
    <header
      className="border-b shadow-[0_6px_9px_rgba(0,0,0,0.05)]"
      style={{ backgroundColor: bg, borderColor: `${fg}26` }}
    >
      <div className="max-w-7xl mx-auto px-4 py-2 sm:py-3 md:py-4 flex items-center justify-between gap-3">
        <img src={logoSrc} alt="Logo" className="h-7 sm:h-9 md:h-12 object-contain shrink-0" />
        <h1
          className="text-sm sm:text-lg md:text-xl font-bold flex-1 min-w-0 text-center truncate"
          style={{ color: fg }}
        >
          {title}
        </h1>
        {isLoggedIn && (
          <Button
            onClick={onLogout}
            variant="ghost"
            className="flex items-center gap-2 shrink-0"
            style={{ color: fg }}
          >
            <LogOut className="w-4 h-4" />
            Sair
          </Button>
        )}
      </div>
    </header>
  );
}
